<template>
  <v-container
    fluid
    grid-list-xl
  >
    <app-desempenho titulo="Desempenho Comportamental">
      <template v-slot:body>
        <v-col
          centered
          cols="12"
          no-gutters
        >
          <v-row v-if="!prazoDisponivel">
            <v-col>
              <app-alert
                icon="watch_later"
                message="O prazo para visualização ainda não está disponível."
                type="info"
              />
            </v-col>
          </v-row>
          <v-row
            v-if="loaded && prazoDisponivel"
            class="justify-center ma-2"
          >
            <v-tabs
              v-model="categoria"
              centered
              icons-and-text
            >
              <v-tabs-slider color="secondary" />
              <v-tab
                v-for="i in categorias.length"
                :key="i"
                :href="'#' + categorias[i - 1].id"
                class="mt-3"
              >
                <span class="grey--text text--darken-2">{{
                  categorias[i - 1].descricao
                }}</span>
                <v-icon
                  :color="
                    categorias[i - 1].id === categoria ? 'secondary' : 'grey'
                  "
                >
                  {{ categorias[i - 1].icone }}
                </v-icon>
              </v-tab>
            </v-tabs>
          </v-row>
          <v-row
            v-if="loaded && prazoDisponivel"
            class="justify-center ma-2"
          >
            <v-col v-if="teveAvaliacao">
              <keep-alive>
                <component
                  :is="currentComponent"
                  :key="currentComponentKey"
                  :desempenho="desempenho"
                  :tipo="categoria"
                />
              </keep-alive>
            </v-col>
            <v-col
              v-else-if="categoria === 'SUBORDINADOS' || categoria === 'PARES'"
            >
              <info-dispensa
                :dispensas="dispensasEquipe"
                :mensagem="motivoNaoTeveAvaliacao"
              />
            </v-col>
            <v-col v-else>
              <app-alert
                :message="motivoNaoTeveAvaliacao"
                type="info"
              />
            </v-col>
          </v-row>
        </v-col>
      </template>
    </app-desempenho>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import AppDesempenho from '@/components/core/AppDesempenho';
import AppAlert from '@/components/core/AppAlert';
import InfoDispensa from '@/components/diagnostico/InfoDispensa';
import ResultadoAvaliacao from '@/components/desempenho/ResultadoAvaliacaoComportamental';
import ResultadoAgrupado from '@/components/desempenho/ResultadoAgrupadoComportamental';
import Data from '@/modules/data';

export default {
  name: 'DesempenhoComportamental',

  components: {
    AppDesempenho,
    AppAlert,
    InfoDispensa,
    ResultadoAvaliacao,
    ResultadoAgrupado,
  },

  data() {
    return {
      currentComponent: '',
      currentComponentKey: '',
      categorias: [
        {
          id: 'AUTOAVALIACAO',
          descricao: 'Autoavaliação',
          icone: 'person',
        },
        {
          id: 'SUBORDINADOS',
          descricao: 'Avaliação da Equipe',
          icone: 'group',
        },
        {
          id: 'PARES',
          descricao: 'Avaliação da Equipe',
          icone: 'group',
        },
        {
          id: 'GESTOR',
          descricao: 'Avaliação do Gestor',
          icone: 'work',
        },
        {
          id: 'AGRUPADO',
          descricao: 'Meu Resultado',
          icone: 'speed',
        },
      ],
      categoria: '',
    };
  },

  computed: {
    ...mapState({
      diagnostico: (state) => state.diagnostico.diagnostico,
      desempenho: (state) => state.desempenho.desempenho,
      isTutorialExibido: (state) => state.tutorial.dados.desempenhoComportamental,
    }),
    loaded: {
      get() {
        return this.$store.state.desempenho.loaded;
      },
      set(status) {
        this.$store.dispatch('desempenho/setLoadedStatus', status);
      },
    },
    graficos: {
      get() {
        return this.$store.state.desempenho.graficosComportamentais;
      },
      set(graficos) {
        const payload = { graficos, perspectiva: 'COMPORTAMENTAL' };
        this.$store.dispatch('desempenho/setGraficos', payload);
      },
    },
    teveAvaliacao() {
      switch (this.categoria) {
        case 'AUTOAVALIACAO':
          return this.desempenho.teveAutoavaliacaoComportamental;
        case 'GESTOR':
          return this.desempenho.teveAvaliacaoGestorComportamental;
        case 'PARES':
          return this.desempenho.pares && this.desempenho.teveAvaliacaoParesComportamental;
        case 'SUBORDINADOS':
          return this.desempenho.equipe && this.desempenho.teveAvaliacaoSubordinadosComportamental;
        case 'AGRUPADO':
          return (
            !this.desempenho.foiDispensado
            && this.desempenho.teveAutoavaliacaoComportamental
            && this.desempenho.teveAvaliacaoGestorComportamental
          );
        default:
          return true;
      }
    },
    motivoNaoTeveAvaliacao() {
      let motivo = '';
      switch (this.categoria) {
        case 'AUTOAVALIACAO':
          return this.desempenho.motivoNaoTeveAutoavaliacaoComportamental;
        case 'GESTOR':
          return this.desempenho.motivoNaoTeveAvaliacaoGestorComportamental;
        case 'PARES':
          return this.desempenho.motivoNaoTeveAvaliacaoPares;
        case 'SUBORDINADOS':
          return this.desempenho.motivoNaoTeveAvaliacaoEquipe;
        case 'AGRUPADO':
          if (this.desempenho.foiDispensado) {
            return this.desempenho.motivoNaoTeveAutoavaliacaoComportamental;
          }

          if (!this.desempenho.teveAutoavaliacaoComportamental || !this.desempenho.teveAvaliacaoGestorComportamental) {
            motivo += 'Resultado inviabilizado.';
            if (!this.desempenho.teveAutoavaliacaoComportamental) {
              motivo += ` (${this.desempenho.motivoNaoTeveAutoavaliacaoComportamental})`;
            }
            if (!this.desempenho.teveAvaliacaoGestorComportamental) {
              motivo += ` (${this.desempenho.motivoNaoTeveAvaliacaoGestorComportamental})`;
            }
          }
          return motivo;
        default:
          return '';
      }
    },
    dispensasEquipe() {
      if (this.diagnostico) {
        return this.$store.state.diagnostico.dispensasEquipe.filter((d) => d.diagnostico.id === this.diagnostico.id);
      }
      return [];
    },
    prazoDisponivel() {
      return Data.compare('isSameOrAfter', { b: this.diagnostico.inicioDesempenho });
    },
  },

  watch: {
    diagnostico() {
      this.loaded = false;
      this.initialize();
    },
    categoria(value) {
      if (this.graficos.loaded) {
        if (value === 'AGRUPADO') {
          this.currentComponent = 'ResultadoAgrupado';
        } else {
          this.currentComponent = 'ResultadoAvaliacao';
        }
        this.currentComponentKey = this.categoria;
      }
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      if (this.prazoDisponivel) {
        if (!this.loaded) {
          this.$store
            .dispatch('desempenho/load', {
              diagnostico: this.diagnostico,
            })
            .then(async () => {
              this.checkPermissoes();
              if (this.desempenho && !this.desempenho.foiDispensado) {
                this.graficos = this.setGraficos(this.desempenho);
                this.categoria = 'ResultadoAvaliacao';
              }
            });
        } else {
          this.checkPermissoes();
          if (!this.graficos.loaded) {
            if (this.desempenho && !this.desempenho.foiDispensado) {
              this.graficos = this.setGraficos(this.desempenho);
            }
          }
          this.currentComponent = 'ResultadoAvaliacao';
        }

        if (!this.isTutorialExibido) {
          await this.$store.dispatch('app/showTutorial', { nome: 'DesempenhoComportamental' });
        }
      }
    },
    checkPermissoes() {
      if (this.desempenho && !this.desempenho.pares) {
        this.removeCategoria('PARES');
      }
      if (this.desempenho && (!this.desempenho.chefia || !this.desempenho.equipe)) {
        this.removeCategoria('SUBORDINADOS');
      }
    },
    setGraficos(desempenho) {
      const categorias = [];
      const notasMaximas = [];
      const notasAutoavaliacao = [];
      const notasGestor = [];
      const notasSubordinados = [];
      const notasPares = [];

      const graficos = {
        bar: {
          autoavaliacao: { categorias: [], dados: [] },
          gestor: { categorias: [], dados: [] },
          subordinados: { categorias: [], dados: [] },
          pares: { categorias: [], dados: [] },
        },
        gauge: { dados: [] },
      };

      desempenho.resultadosComportamentais.forEach((resultado) => {
        categorias.push(resultado.competencia.nome);
        notasMaximas.push(resultado.notaMaxima);

        notasAutoavaliacao.push(resultado.notaAutoavaliacao);
        notasGestor.push(resultado.notaGestor);
        notasSubordinados.push(resultado.notaSubordinados);
        notasPares.push(resultado.notaPares);
      });

      graficos.bar.autoavaliacao.categorias = [...categorias];
      graficos.bar.autoavaliacao.dados.push(
        { name: 'Resultado Máximo', data: notasMaximas, color: '#2D5269' },
        { name: 'Resultado das Avaliações', data: notasAutoavaliacao, color: '#348ECA' },
      );

      graficos.bar.gestor.categorias = [...categorias];
      graficos.bar.gestor.dados.push(
        { name: 'Resultado Máximo', data: notasMaximas, color: '#2D5269' },
        { name: 'Resultado das Avaliações', data: notasGestor, color: '#348ECA' },
      );

      graficos.bar.subordinados.categorias = [...categorias];
      graficos.bar.subordinados.dados.push(
        { name: 'Resultado Máximo', data: notasMaximas, color: '#2D5269' },
        { name: 'Resultado das Avaliações', data: notasSubordinados, color: '#348ECA' },
      );

      graficos.bar.pares.categorias = [...categorias];
      graficos.bar.pares.dados.push(
        { name: 'Resultado Máximo', data: notasMaximas, color: '#2D5269' },
        { name: 'Resultado das Avaliações', data: notasPares, color: '#348ECA' },
      );

      graficos.gauge.dados.push(parseFloat((desempenho.notaAgrupada * 10).toFixed(2)));
      graficos.loaded = true;

      return graficos;
    },
    removeCategoria(categoria) {
      const index = this.categorias.findIndex((c) => c.id === categoria);
      if (index !== -1) {
        this.categorias.splice(index, 1);
      }
    },
  },
};
</script>
